import type { CountRatio } from '../types';

/** Integer-only percent label for display (no float math in API payloads). */
export function formatCountRatioPercent(ratio: CountRatio): string {
  if (ratio.denominator <= 0) return '—';
  const pct = Math.floor((ratio.numerator * 100) / ratio.denominator);
  return `${pct}%`;
}

export function formatCountRatioFraction(ratio: CountRatio): string {
  if (ratio.denominator <= 0) return '—';
  return `${ratio.numerator} / ${ratio.denominator}`;
}
